import { Dialog, DialogRef } from '@angular/cdk/dialog';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, mergeMap, Observable, tap } from 'rxjs';
import { LoadOverlayComponentComponent } from '../app/common/load-overlay-component/load-overlay-component.component';
import { Mutex } from 'async-mutex';

@Injectable()
export class HttpLoaderInterceptor implements HttpInterceptor {
  private dialogRef?: DialogRef<unknown, LoadOverlayComponentComponent>;
  private refCount = 0n;
  private serializeLock = new Mutex();

  constructor(private dialog: Dialog) {}
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.dialogRef == null) {
      this.dialogRef = this.dialog.open(LoadOverlayComponentComponent, {
        width: '100%',
        height: '100%',
        hasBackdrop: true,
        disableClose: true,
      });
    }
    this.refCount++;

    return from(this.serializeLock.acquire()).pipe(
      mergeMap(() => next.handle(req)),
      tap({
        finalize: () => this.httpDone(),
      }),
    );
  }

  protected httpDone() {
    this.serializeLock.release();
    if (this.refCount > 0n) {
      this.refCount--;

      if (this.refCount === 0n) {
        this.dialogRef?.close();
        this.dialogRef = undefined;
      }
    }
  }
}
